import {useMemo, useRef, useState} from "react";
import {Button, Group, Stack, Text} from "@mantine/core";
import {IconPlayerPauseFilled, IconPlayerPlayFilled, IconPlayerStopFilled} from "@tabler/icons-react";
import {CustomCard} from "./card.tsx";

export function Timer() {
  const [startTime, setStartTime] = useState<undefined | Date>()
  const [milliseconds, setMilliseconds] = useState<number>(0)
  const interval = useRef<undefined | Timer>(undefined)

  const formattedTime = useMemo(() => formatTime(milliseconds), [milliseconds])

  return (
    <CustomCard>
      <Stack align="center">
        <Text size="50px">{formattedTime}</Text>

        <Group gap="xs">
          <Button
            size="sm"
            onClick={() => {
              if (interval.current) {
                clearInterval(interval.current)
                interval.current = undefined
                setMilliseconds(ms => ms + 1) // Trigger rerender to propagate the cleared interval
              } else {
                const newStartTime = new Date(new Date().getTime() - milliseconds)
                setStartTime(newStartTime)
                interval.current = setInterval(() => setMilliseconds(new Date().getTime() - (newStartTime.getTime() ?? 0)), 50)
              }
            }}
          >
            {startTime && interval.current ? <IconPlayerPauseFilled/> : <IconPlayerPlayFilled/>}
          </Button>
          <Button
            size="sm"
            onClick={() => {
              clearInterval(interval.current)
              setStartTime(undefined)
              interval.current = undefined
              setMilliseconds(0)
            }}
          >
            <IconPlayerStopFilled/>
          </Button>
        </Group>
      </Stack>
    </CustomCard>
  )
}

function formatTime(ms: number) {
  const seconds = (Math.floor(ms / 1000) % 60).toString().padStart(2, '0')
  const minutes = (Math.floor(ms / 1000 / 60) % 60).toString().padStart(2, '0')
  const hours = Math.floor(ms / 1000 / 60 / 60).toString().padStart(2, '0')

  return hours === '00' ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`
}